import { RouteInfo } from './vertical-menu.metadata';

// Sidebar menu Routes and data
const ROUTES: RouteInfo[] = [

  // -- Menu para Dashboard **/
  new RouteInfo('/app/dashboard', 'Inicio', 'ft-home')
    .addOrder(0),

  // -- Menu para Notificaciones **/
  /*new RouteInfo('/app/notifications', 'Notificaciones')
    .addOrder(0)
    .addTypes(['patient', 'doctor'])
    .addIcon('ft-inbox'),*/


  // -- Menu para Cuentas **/
  new RouteInfo('/app/accounts', 'Cuentas', 'ft-grid')
    .addTypes(['admin'])
    .addOrder(1)
    .addCrudSubMenu(),

  // -- Menu para buscar agendamientos **/
  new RouteInfo('/app/schedule/search', 'Buscar Turnos', 'ft-search')
    .addTypes(['patient'])
    .addOrder(1)
    .exact(false),

  // -- Menu para consultas **/
  /*new RouteInfo('/app/consultations', 'Consultas', 'ft-align-left')
    .addOrder(2)
    //.addTypes(['assistant'])
    //.addTypes(['patient', 'doctor', 'assistant'])
    .addTypes(['doctor'])
    .exact(false)
    .addSubMenu([
      new RouteInfo('/app/consultations', 'Listado')
        .addIcon('ft-menu')
        .exact(false),
      new RouteInfo('/app/consultations/schedule', 'Agendar')
        .addIcon('ft-calendar'),
    ]),
*/


  /*new RouteInfo('/app/consultations', 'Consultas', 'ft-align-left')
    .addOrder(2)
    //.addTypes(['assistant'])
    //.addTypes(['patient', 'doctor', 'assistant'])
    .addTypes(['doctor'])
    .exact(false)
    .addSubMenu([
      new RouteInfo('/app/consultas', 'Listado')
        .addIcon('ft-menu')
        .exact(false),
      new RouteInfo('/app/consultas/schedule', 'Agendar')
        .addIcon('ft-calendar'),
    ]),*/
  /*new RouteInfo('/app/prescriptions', 'Prescripciones')
    .addOrder(3)
    .addIcon('ft-file-text')
    .addTypes(['patient', 'doctor']),

  // -- Menu para Ficha Medica paciente **/
  /*new RouteInfo('/app/medical-records', 'Ficha Médica')
    .addOrder(4)
    .addTypes(['patient'])
    .addIcon('ft-clipboard'),*/


  // -- Menu para Adherentes **/
  /*new RouteInfo('/app/users', 'Adherentes')
    .addOrder(5)
    .addTypes(['patient'])
    .addIcon('ft-users')
    .addCrudSubMenu(),*/
  // -- Menu para Pacientes **/
  new RouteInfo('/app/plan-doctors', 'Planes de Doctores')
    .addOrder(5)
    .addTypes(['admin'])
    .addIcon('ft-activity')
    .addCrudSubMenu(),


  // -- Menu para Validaciones **/
  new RouteInfo('/app/pagopar-transactions', 'Pagos en pagopar', 'ft-grid')
    .addTypes(['admin'])
    .addOrder(6)
    .addCrudSubMenu(),

  // -- Menu para Pacientes **/
  new RouteInfo('/app/patients', 'Pacientes')
    .addOrder(7)
    .addTypes(['doctor', 'assistant', 'admin'])
    .addIcon('ft-activity')
    .addCrudSubMenu(),


  // -- Menu para Doctores **/
  new RouteInfo('/app/doctors', 'Profesionales')
    .addOrder(7)
    .addTypes(['assistant', 'admin'])
    .addIcon('ft-plus-square')
    .addCrudSubMenu(),

  // -- Menu para Medicinas **/
  new RouteInfo('/app/medicines', 'Medicinas', 'ft-heart-on')
    .addTypes(['admin'])
    .addOrder(7)
    .exact(false)
    .addCrudSubMenu()
    .addSubMenu([
      // -- Menu para Unidades de medidas **/
      new RouteInfo('/app/measurements', 'Un. de Medida', 'ft-box')
        .addTypes(['admin'])
        .addOrder(1)
        .addCrudSubMenu(),

      // -- Menu para Laboratorios **/
      new RouteInfo('/app/laboratories', 'Laboratorios', 'ft-thermometer')
        .addTypes(['admin'])
        .addOrder(1)
        .addCrudSubMenu(),
    ]),


  // -- Menu para Configuracion de Agenda de Doctores **/
  /*new RouteInfo('/app/schedule/view', 'Agenda', 'ft-calendar')
    .addTypes(['admin', 'doctor', 'assistant'])
    .addOrder(8)
    .addSubMenu([
      new RouteInfo('/app/schedule/view', 'Calendario')
        .addIcon('ft-calendar'),
      new RouteInfo('/app/schedule/config', 'Configurar')
        .addIcon('ft-settings')
    ]),
    */

  // -- Menu para Transcripciones **/
  /* new RouteInfo('/app/transcriptions', 'Transcripciones', 'ft-mic')
     .addTypes(['admin'])
     .addOrder(8),*/


  // -- Menu para Asistentes **/
  /*new RouteInfo('/app/assistants', 'Asistentes')
    .addOrder(9)
    .addTypes(['doctor', 'admin'])
    .addIcon('ft-users')
    .addCrudSubMenu(),*/


  // -- Menu para Usuarios **/
  new RouteInfo('/app/users', 'Usuarios', 'ft-users')
    .addTypes(['admin'])
    .addOrder(10)
    .addCrudSubMenu(),


  // -- Menu para Seguros medicos **/
  new RouteInfo('/app/insurances', 'Seguros Médicos', 'ft-plus-circle')
    .addTypes(['admin'])
    .addOrder(11)
    .addCrudSubMenu(),


  // -- Menu para Validaciones **/
  new RouteInfo('/app/validations', 'Validaciones', 'ft-check-circle')
    .addTypes(['admin'])
    .addOrder(50)
    .exact(false),

  // -- Menu para Validaciones **/
  new RouteInfo('/app/solicit-credit', 'Créditos', 'ft-dollar-sign')
    .addTypes(['admin', 'doctor'])
    .addOrder(51)
    .exact(false)
    .addSubMenu([
      new RouteInfo('/app/solicit-credit', 'Listado').addIcon('ft-menu'),
      new RouteInfo('/app/solicit-credit/add', 'Solicitar Nuevo').addIcon('ft-plus')
    ]),


  // -- Menu para Validaciones **/
  new RouteInfo('/app/doctor-bank-account', 'Cuentas Bancarias', 'ft-grid')
    .addTypes(['admin', 'doctor'])
    .addOrder(51)
    .exact(false),

  new RouteInfo('/app/presupuestos', 'Presupuestos', 'ft-dollar-sign')
    .addTypes(['admin', 'doctor'])
    .addOrder(53)
    .exact(false)
    .addSubMenu([
      new RouteInfo('/app/presupuestos', 'Listado').addIcon('ft-menu'),
      new RouteInfo('/app/presupuestos/add', 'Presupuesto Nuevo').addIcon('ft-plus')
    ]),


  // -- Menu para Validaciones **/
  new RouteInfo('/app/solicitud-protesis', 'Solicitudes de prótesis', 'ft-grid')
    .addTypes(['admin', 'doctor'])
    .addOrder(53)
    .addCrudSubMenu(),

  // -- Menu para Validaciones **/
  new RouteInfo('/app/consultas', 'Mis consultas', 'ft-grid')
    .addTypes(['admin', 'doctor'])
    .addOrder(54)
    .addCrudSubMenu(),


  // -- Menu para Configuraciones **/
  new RouteInfo('/app/system-configurations', 'Configuraciones', 'ft-settings')
    .addTypes(['admin'])
    .addOrder(70)
    .addSubMenu([

      // -- Menu para configuracion de Planes **/
      /*new RouteInfo('/app/plans/plan-configurations', 'Planes', 'ft-layers')
        .addTypes(['admin'])
        .addOrder(1)
        .addCrudSubMenu(),*/

      new RouteInfo('/app/banks', 'Bancos', 'ft-layers')
        .addTypes(['admin'])
        .addOrder(1)
        .addCrudSubMenu(),

      // -- Menu para Especialidades Medicas **/
      new RouteInfo('/app/medical-specialities', 'Especialidades', 'ft-clipboard')
        .addTypes(['admin'])
        .addOrder(2)
        .addCrudSubMenu(),

      // -- Menu para Estudios Medicos **/
      new RouteInfo('/app/medical-studies', 'Estudios', 'fa fa-stethoscope')
        .addTypes(['admin'])
        .addOrder(3)
        .addCrudSubMenu(),

      // -- Menu para Diagnosticos **/
      new RouteInfo('/app/diagnostic-center', 'Centro de Diagnósticos', 'fa fa-dot-circle-o')
        .addTypes(['admin'])
        .addOrder(4)
        .addCrudSubMenu(),
      // -- Menu para Diagnosticos **/
      new RouteInfo('/app/laboratorio_protesis', 'Laboratorio Prótesis', 'fa fa-dot-circle-o')
        .addTypes(['admin'])
        .addOrder(5)
        .addCrudSubMenu(),


      // -- Menu para Configuraciones de Sistema **/
      new RouteInfo('/app/system-configurations', 'Sistema', 'ft-settings')
        .addTypes(['admin'])
        .addOrder(7)
        .addCrudSubMenu(),
    ])
    .exact(false),


  // -- Menu para Cuentas **/
  /*
  new RouteInfo('/app/profile', 'Cuenta')
    .addIcon('ft-user')
    .addOrder(100)
    .addSubMenu([
      new RouteInfo('/app/profile', 'Datos Básicos'),
      new RouteInfo('/app/profile/edit', 'Editar'),
      new RouteInfo('/mode-selector', 'Cambiar panel'),
    ])
    .exact(false),
    */


  // -- Menu para Billing **/
  /*new RouteInfo('/app/billing', 'Planes & Pagos')
    .addIcon('ft-credit-card')
    .addOrder(150)
    .exact(false)
    .addSubMenu([
      new RouteInfo('/app/plans', 'Planes').exact(false),
      new RouteInfo('/app/billing/invoices', 'Recibos de Pago'),
      new RouteInfo('/app/billing/payment-methods', 'Métodos de Pago')
    ]),
    */

  // -- Menu para Reportes **/
  /*
  new RouteInfo('/app/reports/invoicing', 'Reportes')
    .addIcon('ft-bar-chart-2')
    .addOrder(200)
    .exact(false)
    .addSubMenu([
      new RouteInfo('/app/reports/invoices', 'Pagos'),
      new RouteInfo('/app/reports/consultations', 'Consultas'),
      new RouteInfo('/app/reports/diagnoses', 'Diagnósticos Médicos'),
      new RouteInfo('/app/reports/patients-treated', 'Pacientes Tratados'),
      new RouteInfo('/app/reports/prescriptions', 'Prescripciones')
        .addSubMenu([
          new RouteInfo('/app/reports/prescriptions/medicines', 'Medicamentos').exact(false),
          new RouteInfo('/app/reports/prescriptions/interconsultations', 'Interconsultas').exact(false),
          new RouteInfo('/app/reports/prescriptions/medical-studies', 'Estudios Médicos').exact(false),
        ])
        .exact(false),
    ]),
    */
];

/**
 * Obtener las rutas de acuerdo al tipo de panel
 *
 */
export function getMenuRoutes(type): RouteInfo[] {

  let routes: RouteInfo[] = ROUTES.filter(value => value.type.includes(type) || value.type.includes('all'));

  // Se ordenan las rutas
  routes = routes.sort((data, data2) => data.order - data2.order);

  return routes;
}
